import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {
    faCheck,
    faXmark,
    faSignOut,
    faArrowUpRightFromSquare,
    faEdit,
    faPlus,
    faBan,
    faEnvelopeOpen,
    faCircleExclamation,
    faUpload,
    faDownload,
    faLayerGroup,
    faBolt,
    faCoins,
    faChartBar,
    faChartLine,
    faIndustry,
    faBuilding,
    faChargingStation,
    faInfoCircle,
    // New navigation icons
    faHome,
    faCalendarAlt,
    faDatabase,
    faCog,
    faUsers,
    faClipboardList,
    faLink,
    faHardHat,
    faGauge,
    faArrowRight,
    faChevronLeft,
    faChevronRight,
    faMoneyBillTrendUp,
} from "@fortawesome/free-solid-svg-icons";
import {SizeProp} from "@fortawesome/fontawesome-svg-core";

// Existing icons
export const LayerGroupIcon = () => <FontAwesomeIcon icon={faLayerGroup}/>
export const BoltIcon = () => <FontAwesomeIcon icon={faBolt}/>
export const CoinsIcon = () => <FontAwesomeIcon icon={faCoins}/>
export const ChartBarIcon = () => <FontAwesomeIcon icon={faChartBar}/>
export const ChartLineIcon = () => <FontAwesomeIcon icon={faChartLine}/>

export const TrashIcon = () => <FontAwesomeIcon icon={faTrashCan}/>

export const CrossIcon = () => <FontAwesomeIcon icon={faXmark}/>
export const PlusIcon = () => <FontAwesomeIcon icon={faPlus}/>

export const TickIcon = () => <FontAwesomeIcon icon={faCheck}/>
export const EditIcon = () => <FontAwesomeIcon icon={faEdit}/>

export const UploadIcon = () => <FontAwesomeIcon icon={faUpload}/>
export const DownloadIcon = () => <FontAwesomeIcon icon={faDownload}/>

export const CircleAlertIcon = () => <FontAwesomeIcon data-testid="circle-exclamation-icon" icon={faCircleExclamation} />
export const CircleInfoIcon = ({size}: IconProps) => <FontAwesomeIcon icon={faInfoCircle} size={size}/>

export const BanIcon = () => <FontAwesomeIcon icon={faBan} />

export const HomeIcon = () => <FontAwesomeIcon icon={faHome}/>
export const CalendarIcon = () => <FontAwesomeIcon icon={faCalendarAlt}/>
export const DataIcon = () => <FontAwesomeIcon icon={faDatabase}/>
export const MeteringIcon = () => <FontAwesomeIcon icon={faGauge}/>
export const OnboardIcon = () => <FontAwesomeIcon icon={faClipboardList}/>
export const ScheduleIcon = () => <FontAwesomeIcon icon={faCalendarAlt}/>
export const AdminIcon = () => <FontAwesomeIcon icon={faUsers}/>
export const PrepareIcon = () => <FontAwesomeIcon icon={faHardHat}/>
export const LinkIcon = () => <FontAwesomeIcon icon={faLink}/>
export const DeviceLinkIcon = () => <FontAwesomeIcon icon={faCog}/>

export interface IconProps {
    size?: SizeProp
}
export const SignOutIcon = ({size}: IconProps) => <FontAwesomeIcon icon={faSignOut} size={size}/>
export const ContactUs = ({size}: IconProps) => <FontAwesomeIcon icon={faEnvelopeOpen} size={size}/>

export const ArrowUpFromSquare = ()=> <FontAwesomeIcon icon={faArrowUpRightFromSquare} color={'primary'} size={'sm'}/>

export const ArrowRight = () =>  <FontAwesomeIcon icon={faArrowRight} style={{ color: '#757575' }} />

export const CollapseIcon = () => <FontAwesomeIcon icon={faChevronLeft} />
export const ExpandIcon = () => <FontAwesomeIcon icon={faChevronRight} />

export const PowerStationIcon = () => <FontAwesomeIcon icon={faIndustry} />
export const OfficeIcon = () => <FontAwesomeIcon icon={faBuilding} />
export const ChargerIcon = () => <FontAwesomeIcon icon={faChargingStation} />
export const DashboardIcon = () => <FontAwesomeIcon icon={faGauge} />
export const P415Icon = () => <FontAwesomeIcon icon={faMoneyBillTrendUp} />